// ============================================================================
// COMPONENT - ComponentCategoryList.jsx
// ============================================================================
// client/src/components/labEngine/componentCategoryList.jsx

import React from 'react';
import './componentCategoryList.css';

const ComponentCategoryList = ({
  categoryKey,
  categoryName,
  categoryIcon,
  domain,
  components,
  isExpanded,
  onToggle,
  onDragStart,
  onViewComponent,
  showViewButton,
  onShowInfo,
  onConfigureComponent,
  emptyMessage,
  courseTitle,    // ← NEW: e.g. "IoT Fundamentals"
  userRole,       // ← NEW: e.g. "admin", "instructor", "student"
}) => {

  // ── Authorization helper ──────────────────────────────────────────────────
  const isAuthorized = (comp) => {
    // Admins always see everything unlocked
    if (userRole === 'admin') return true;
    // No courses restriction defined → available to all
    if (!comp.courses || comp.courses.length === 0) return true;
    // Check if current course title is in the component's courses array
    return courseTitle ? comp.courses.includes(courseTitle) : false;
  };

  const lockTooltip = (comp) => {
    if (!comp.courses || comp.courses.length === 0) return '';
    return `🔒 Not available for this course. Designed for: ${comp.courses.join(', ')}`;
  };

  return (
    <div className="component-category">
      {/* Category Header */}
      <div className="component-category-header" onClick={onToggle}>
        <span className="category-toggle-icon">{isExpanded ? '▼' : '▶'}</span>
        {/* <h4>{categoryIcon} {categoryName}</h4> */}
        <h4>{categoryName}</h4>
        <span className="category-count">{components?.length || 0}</span>
      </div>

      {/* Component List */}
      {isExpanded && (
        <div className="component-list">
          {components && components.length > 0 ? (
            components.map(comp => {
              const authorized = isAuthorized(comp);
              return (
                <div
                  key={comp.componentId || comp._id}
                  className="component-item-wrapper"
                >
                  <div
                    className={`component-item ${!authorized ? 'component-item--locked' : ''}`}
                    draggable={authorized}
                    onDragStart={authorized ? () => onDragStart(comp) : (e) => e.preventDefault()}
                    title={!authorized ? lockTooltip(comp) : comp.name}
                  >
                    {/* Lock overlay */}
                    {!authorized && (
                      <div className="component-lock-overlay" title={lockTooltip(comp)}>
                        🔒
                      </div>
                    )}

                    <span className="component-icon-small">{comp.icon}</span>
                    <span className="component-name">{comp.name}</span>

                    {/* View button — instructor/admin only */}
                    {showViewButton && onViewComponent && (
                      <button
                        className="component-info-btn"
                        onClick={(e) => onViewComponent(comp, e)}
                        title="View/Edit component"
                      >
                        👁️
                      </button>
                    )}

                    {/* Info button — all users, only when authorized */}
                    {authorized && onShowInfo && (
                      <button
                        className="component-info-btn"
                        onClick={(e) => onShowInfo(comp, e)}
                        title="Component information"
                      >
                        ℹ️
                      </button>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="component-category-empty">
              {emptyMessage || `No ${categoryName.toLowerCase()} available`}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default ComponentCategoryList;